import React from 'react';
import {
	Box,
	Center,
	Flex,
	Icon,
	Spinner,
	Text,
	VStack,
} from '@chakra-ui/react';
import { FaInfoCircle } from 'react-icons/fa';
import SubscriptionPlanMatrix from './SubscriptionPlanMatrix';
import PlanBillingToggle from './PlanBillingToggle';

/**
 * Card-wrapped plan comparison table — same layout as SubscribeToPlanFirstTimePage.
 */
const PlanComparisonMatrixPanel = ({
	plans = [],
	isYearly,
	onBillingCycleChange,
	onSelectPlan,
	onUpdatePlan,
	isLoading = false,
	stickyHeaderOffset = '0px',
	firstTimeSubscribe = true,
	showMoneyBackGuarantee = false,
	headerTitle = 'Compare subscription plans',
	headerHint,
	showBillingToggle = true,
	headerExtra,
	currentPlanId,
	subscriptionPriceId,
	planMongoId,
	currentPlanName,
	currentPlanPrice,
	subscriptionStatus,
	pricingMode = 'subscription',
	matrixProps = {},
}) => {
	return (
		<Box
			bg='white'
			borderRadius='2xl'
			border='1px solid'
			borderColor='gray.100'
			boxShadow='sm'
			overflow='visible'>
			<Box
				px={{ base: 4, md: 6 }}
				py={4}
				borderBottom='1px solid'
				borderColor='gray.100'
				bg='gray.50'
				borderTopRadius='2xl'>
				<Flex justify='space-between' align='center' flexWrap='wrap' gap={3}>
					<Box flex='1' minW='200px'>
						<Text fontWeight='700' color='gray.800' m={0}>
							{headerTitle}
						</Text>
						{headerHint ? (
							<Text fontSize='xs' color='orange.500' fontWeight='500' mt={1} m={0}>
								<Icon as={FaInfoCircle} color='orange.500' boxSize={3} mr={1} />
								{headerHint}
							</Text>
						) : null}
					</Box>

					{headerExtra}

					{showBillingToggle && typeof onBillingCycleChange === 'function' ? (
						<PlanBillingToggle
							isYearly={isYearly}
							onChange={onBillingCycleChange}
							variant='light'
							size='sm'
						/>
					) : null}
				</Flex>
			</Box>

			<Box px={{ base: 2, md: 4 }} py={4} borderBottomRadius='2xl' overflow='visible'>
				{isLoading ? (
					<Center py={12}>
						<VStack spacing={3}>
							<Spinner size='lg' color='teal.400' />
							<Text fontSize='sm' color='gray.500' m={0}>
								Loading plans...
							</Text>
						</VStack>
					</Center>
				) : !plans?.length ? (
					<Center py={12}>
						<Text fontSize='sm' color='gray.500' m={0}>
							No plans are available yet.
						</Text>
					</Center>
				) : (
					<SubscriptionPlanMatrix
						plans={plans}
						onSelectPlan={onSelectPlan}
						onUpdatePlan={onUpdatePlan}
						showPrice
						isYearly={isYearly}
						onBillingCycleChange={onBillingCycleChange}
						bgColor='white'
						stickyPlanHeader
						stickyHeaderOffset={stickyHeaderOffset}
						firstTimeSubscribe={firstTimeSubscribe}
						currentPlanId={currentPlanId}
						subscriptionPriceId={subscriptionPriceId}
						planMongoId={planMongoId}
						currentPlanName={currentPlanName}
						currentPlanPrice={currentPlanPrice}
						subscriptionStatus={subscriptionStatus}
						showMoneyBackGuarantee={showMoneyBackGuarantee}
						pricingMode={pricingMode}
						{...matrixProps}
					/>
				)}
			</Box>
		</Box>
	);
};

export default PlanComparisonMatrixPanel;
